<template>
<el-card class="box-card" shadow="hover">
  <div slot="header" class="clearfix" style="position:relative">
    <el-breadcrumb>
      <el-breadcrumb-item>售后管理</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="text item">
    <el-tabs v-model="sreachData.status" @tab-click="handleClick">
      <el-tab-pane label="全部售后订单" name="0"></el-tab-pane>
      <el-tab-pane label="待审核" name="1"></el-tab-pane>
      <el-tab-pane label="申请通过" name="2"></el-tab-pane>
      <el-tab-pane label="申请不通过" name="3"></el-tab-pane>
    </el-tabs>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="下单时间">
        <el-date-picker
          v-model="sreachData.createTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="请选择开始时间"
          end-placeholder="请选择结束时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setWeek">最近一周</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setMonth">最近一个月</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setThreeMonth">最近三个月</el-button>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="状态">
        <el-select v-model="sreachData.status" placeholder="订单状态">
          <el-option label="全部售后订单" value="0">全部售后订单</el-option>
          <el-option label="待审核" value="1">待审核</el-option>
          <el-option label="申请通过" value="2">申请通过</el-option>
          <el-option label="申请不通过" value="3">申请不通过</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="sreachData.words" placeholder="输入订单号、会员名、手机号">
          <template slot="prepend"><i class="el-icon-search"></i></template>
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      tooltip-effect="dark"
      :data="tableData"
      style="width: 100%"
      row-key="id"
      border
      default-expand-all
      :tree-props="{children: 'supplierlist'}"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="sn"
        label="订单号">
      </el-table-column>
      <el-table-column
        prop="gcode"
        label="物料号">
      </el-table-column>
      <el-table-column
        prop="title"
        label="物料名称">
      </el-table-column>
      <el-table-column
        prop="unit"
        label="单位">
      </el-table-column>
      <el-table-column
        prop="num"
        label="订单数量">
      </el-table-column>
      <el-table-column
        prop="name"
        label="联系人">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="联系电话">
      </el-table-column>
      <el-table-column
        width="110"
        label="方式">
        <template slot-scope="scope">
          <p v-if="scope.row.type==1">退货</p>
          <p v-else>换货</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="noNum"
        label="申请数量">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="原因">
      </el-table-column>
      <el-table-column
        prop="createTime"
        width="140"
        label="申请时间">
      </el-table-column>
      <el-table-column
        width="100"
        label="状态">
        <template slot-scope="scope">
          <p v-if="scope.row.status==1">待审核</p>
          <p v-else-if="scope.row.status==2">通过审核</p>
          <p v-else-if="scope.row.status==3">不通过</p>
          <p v-else>完成</p>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="220">
        <template slot-scope="scope">
          <el-button v-show="scope.row.status==1&&showBtn==3" size="mini" type="primary" plain @click="serviceOver(scope.row.id,2)">审核通过</el-button>
          <el-button v-show="scope.row.status==1&&showBtn==3" size="mini" type="primary" plain @click="serviceOver(scope.row.id,3)">审核不通过</el-button>
          <!-- <el-button v-show="showBtn==3" size="mini" type="success" plain @click="editOrder(scope.row.id)">详情</el-button> -->
          <el-popconfirm
            confirm-button-text='好的'
            cancel-button-text='不用了'
            icon="el-icon-info"
            icon-color="red"
            @confirm="del(scope.row.id)" 
            title="确定删除售后订单吗？"
          >
            <el-button v-if="showBtn==0||showBtn==5" size="mini" type="danger" plain slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <p>
      <!-- <span style="float:left">
        <el-button @click="delOrders()">删除所选</el-button>
      </span> -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="sreachData.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="sreachData.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </p>
  </div>
  
</el-card>
</template>
<script>
import serviceFunction from "@/api/service"
export default {
  data() {
    return {
      showBtn:sessionStorage.getItem('roleid'),
      total:0,
      activeName:"",
      Selectionids:[],
      sreachData:{
        createTime:[],
        page:1,
        limit:10,
        status:'',
        words:'',
        vcode:sessionStorage.getItem('token'),
      },
      tableData:[],
      form:{
        gcode:'',
        cgcode:'',
        title:'',
        unit:'',
        price:'',
        remark:'',
        factory:'',
        purchase:'',
        locator:'',
        num:'',
        orderRemark:'',
        examine:0,
        examineMsg:'',
        vcode:sessionStorage.getItem('token'),
      }
    }
  },
  methods:{
    setWeek(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      this.sreachData.createTime = [start,end]
    },
    setMonth(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.sreachData.createTime = [start,end]
    },
    setThreeMonth(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      this.sreachData.createTime = [start,end]
    },
    handleSizeChange(val){
      this.sreachData.limit = val
      this.getList()
    },
    handleCurrentChange(val){
      this.sreachData.page = val
      this.getList()
    },
    getList(){
      serviceFunction.list(this.sreachData,this).then(res=>{
        this.tableData = res.data
        this.total = res.total
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    handleClick(){
      this.sreachData.status = this.activeName;
      this.getList()
    },
    search(){
      this.sreachData.page=1
      this.tableData = []
      this.getList()
    },
    handleSelectionChange(val) {
      this.Selectionids = []
      for(var i in val){
        this.Selectionids.push(val[i].id);
      }
    },
    serviceOver(id,status){
        serviceFunction.edit({id:id,status:status,vcode:sessionStorage.getItem('token')},this).then(res=>{
            this.getList()
        }).catch(err=>{
            this.$message.error(err)
        })
    },
    del(id){
        serviceFunction.del({id:id,vcode:sessionStorage.getItem('token')},this).then(res=>{
            this.getList()
        }).catch(err=>{
            this.$message.error(err)
        })
    }
  },
  mounted () {
    this.getList()
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/servicelist.vue